module.exports = __webpack_public_path__ + "static/media/soccer-pre-match.827c38c6.pdf";